import { useState, useRef, useEffect, useCallback } from "react";
import { formActivity } from '../realtime/formActivity';

export const useFormState = (initialFormData) => {
  const [formData, updateFormData] = useState(initialFormData);
  const owner = useRef(Symbol('form'));
  const baseline = useRef(initialFormData);
  const current = useRef(initialFormData);
  useEffect(() => {
    const key = owner.current;
    return () => formActivity.draft(key, false);
  }, []);
  const setFormData = useCallback(value => {
    const next = typeof value === 'function' ? value(current.current) : value;
    current.current = next;
    baseline.current = next;
    formActivity.draft(owner.current, false);
    updateFormData(next);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const next = {
      ...current.current,
      [name]: value, // Update formData based on input change
    };
    current.current = next;
    formActivity.draft(owner.current, JSON.stringify(next) !== JSON.stringify(baseline.current));
    updateFormData(next);
  };

  return { formData, handleChange, setFormData };
};
